import cx from 'classnames';
import { useState } from 'react';
import { useTranslation } from '../i18n';

function Rate({ rate, onRate }) {
  const { t } = useTranslation();
  const [ratedNow, setRatedNow] = useState(false);
  const onClickRate = newRate => {
    onRate(newRate);
    setRatedNow(true);
  };
  return (
    <div>
      <div>{t('rateHeader')}</div>
      <div className="icons">
        <button
          type="button"
          className={cx('transparent', {
            selected: rate === -1,
            faded: rate != null && rate !== -1,
          })}
          onClick={() => onClickRate(-1)}
        >
          <img
            src="https://cdn.infoset.app/emojis/people/disappointed-face.png"
            alt="disappointed face"
          />
        </button>
        <button
          type="button"
          className={cx('transparent', { selected: rate === 0, faded: rate != null && rate !== 0 })}
          onClick={() => onClickRate(0)}
        >
          <img src="https://cdn.infoset.app/emojis/people/neutral-face.png" alt="neutral face" />
        </button>
        <button
          type="button"
          className={cx('transparent', { selected: rate === 1, faded: rate != null && rate !== 1 })}
          onClick={() => onClickRate(1)}
        >
          <img
            src="https://cdn.infoset.app/emojis/people/grinning-face-with-big-eyes.png"
            alt="grinning face"
          />
        </button>
      </div>
      {/* TODO: do something on bad feedback, like trigger chat or notify people */}
      {rate != null && ratedNow && <small className="feedback">{t('rateThanks')}</small>}
      <style jsx>
        {`
          .icons {
            text-align: center;
          }
          .icons button {
            width: 50px;
            height: 50px;
            padding: 0;
            margin: 7px;
            color: #ffdc00;
            cursor: pointer;
            transform: scale(0.75);
            transition: transform 0.2s, filter 0.1s;
          }
          .icons button.faded {
            filter: grayscale(100%);
          }
          .icons button.selected,
          .icons button:hover {
            transform: scale(1);
          }
        `}
      </style>
    </div>
  );
}

export default Rate;
